"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedCountryResponse = void 0;
const country_region_1 = require("../../common-interfaces/country-region");
exports.mockedCountryResponse = {
  id: 723,
  abv: 'AR',
  abv3: 'ARG',
  code: 32,
  slug: 'argentina',
  regionAbv: country_region_1.europeRegion.abv,
  name: {
    id: 968,
    en: 'Argentina',
    ru: 'Аргентина'
  },
  rating: 10
};